import { ApolloClient } from 'apollo-client'
import { onError, ErrorResponse } from 'apollo-link-error'
import { HttpLink, InMemoryCache, from, ApolloLink } from 'apollo-boost'

const httpLink = new HttpLink({ uri: process.env.REACT_APP_FIRE_CLOUD_API_URL })

// Strip __typename (used for apollo caching) from variables, because it breaks mutation queries..
// https://github.com/apollographql/apollo-client/issues/1564
const middleWareLink = new ApolloLink((operation, forward) => {
  if (operation.variables) {
    const omitTypename = (key: string, value: any) =>
      key === '__typename' ? undefined : value

    operation.variables = JSON.parse(
      JSON.stringify(operation.variables),
      omitTypename
    )
  }
  return forward(operation)
})

const errorLink = onError(({ graphQLErrors, networkError }: ErrorResponse) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, path }) => {
      console.error(`[GraphQL error]: Message: ${message}, Path: ${path}`)
    })
  }

  if (networkError) console.error(`[Network error]: ${networkError}`)
})

const fireGQLClient = new ApolloClient({
  link: from([errorLink, middleWareLink, httpLink]),
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'network-only',
      errorPolicy: 'all',
    },
  },
})

export default fireGQLClient // 🔥🔥🔥
